export default __webpack_public_path__ + "static/media/504.ec2e0ec3.png";